export default {
  name: "",
  streetAddress: "",
  area: "",
  country: "",
  lat: "",
  lng: "",
  type: ""
}
